import { getLanguageCode } from 'js/lib/language';
import path from 'js/lib/path';

import type { PartnerPageQuery_PartnersV1Resource_shortName_partners_courses_elements as CourseData } from 'bundles/partners-graphql/components/__generated__/PartnerPageQuery';

export function sortCourses(courses: CourseData[]): CourseData[] {
  let sortedCourses = courses;

  // Filter out spark and standalone courses
  sortedCourses = sortedCourses.filter((course) => {
    return !(course.courseType != null && course.courseType.indexOf('v1') === 0);
  });

  // Sort alphabetically by name
  sortedCourses.sort((a, b) => a.name.localeCompare(b.name));

  // "Boost" courses in the language of the learner
  sortedCourses.sort((a, b) => {
    const boostLanguage = getLanguageCode();

    const aHasBoostLanguage = a.primaryLanguages.includes(boostLanguage);
    const bHasBoostLanguage = b.primaryLanguages.includes(boostLanguage);

    if (aHasBoostLanguage && !bHasBoostLanguage) return -1;
    if (!aHasBoostLanguage && bHasBoostLanguage) return 1;
    return 0;
  });

  // Sort launched courses before preenroll courses and then preenroll courses by date
  sortedCourses.sort((a, b) => {
    const statusOrder = ['launched', 'preenroll'];

    if (a.courseStatus === null) return 0;
    if (b.courseStatus === null) return 0;

    // Compare courseStatus of both courses based on their index in statusOrder array
    const statusComparison = statusOrder.indexOf(a.courseStatus) - statusOrder.indexOf(b.courseStatus);

    if (statusComparison !== 0) {
      return statusComparison;
    }

    if (
      a.courseStatus === 'preenroll' &&
      b.courseStatus === 'preenroll' &&
      a.plannedLaunchDate &&
      b.plannedLaunchDate
    ) {
      const dateA = new Date(a.plannedLaunchDate).getTime();
      const dateB = new Date(b.plannedLaunchDate).getTime();
      return dateA - dateB; // Most recent first
    }

    return 0;
  });

  return sortedCourses;
}

export function isOnDemand(course: CourseData) {
  return course.courseType === 'v2.ondemand' || course.courseType === 'v2.capstone';
}

export function getLink(course: CourseData) {
  return path.join('/', isOnDemand(course) ? 'learn' : 'course', course.slug);
}
